<div class="index-shell">
    <app-header [breadcrumbs]="['Reports', mainHeading]" mainHeading='{{mainHeading}}' [links]="['/reports', '/reports/' + path]">
        <h4 subHeading class="header-sub-heading"> {{ startDate | appDate: 'dd/MM/yyyy' }} - {{ endDate | appDate: 'dd/MM/yyyy' }}</h4>
        <div headingButton>
            <button class="add-button" cll-icon-button (click)="refreshReport()">
                <cll-icon type="outlined">refresh</cll-icon>
            </button>

            <button *ngIf="tableData.length > 0" class="add-button" cll-icon-button (click)="downloadReport()">
                <cll-icon type="outlined">download</cll-icon>
            </button>
        </div>
    </app-header>

    <div class="report-shell">
        <div class="tabs-table-container">
            @if (tableHeaders.length > 0 && tableData.length > 0) {
            <table class="cll-table">
                <thead>
                <tr>
                    <th *ngFor="let header of tableHeaders">{{ formatHeader(header) }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let row of tableData">
                    <td *ngFor="let header of tableHeaders">{{ row[header] }}</td>
                </tr>
                </tbody>
            </table>}
            @else {
            <div class="no-data-container">
                <cll-icon type="outlined" [size]="48">assignment_late</cll-icon>
                <h2 class="no-data-heading">No data available for the selected report.</h2>
                <span class="no-data-sub-heading">Try changing filters and re run.</span>
            </div>
            }
        </div>
    </div>
    <div>
        <cll-card>
            <cll-card-footer>
                <p class="text-body-medium"
                    cllCardFooterStart>
                    Total: {{ tableData.length }}
                </p>
            </cll-card-footer>
        </cll-card>
    </div>
</div>
